import React, { Dispatch, FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import { remove } from 'assets/icons';
import { IMultipleEditForm } from 'types/tep';
import { Tooltip } from 'components/atoms/tooltip';
import { SvgWrapper } from 'components/atoms/svg-wrapper';
import { actions as leasesActions } from 'core/redux/api/veta/tep/leases';

import styles from './styles.module.css';

interface IActionsProps {
  rowIndex: number;
  removeLease: Dispatch<number>;
}

export const Actions: FC<IActionsProps> = ({ rowIndex, removeLease }) => {
  const { getValues } = useFormContext<IMultipleEditForm>();

  const dispatch = useDispatch();

  const close = () => dispatch(leasesActions.close());

  const onRemove = () => {
    const isLast = getValues().leases.length === 1;

    removeLease(rowIndex);
    isLast && close();
  };

  return (
    <div className={styles.actions}>
      <Tooltip text="remove">
        <SvgWrapper width={24} height={24} details={remove} onClick={onRemove} />
      </Tooltip>
    </div>
  );
};
